import _extends from '@babel/runtime/helpers/extends';
import { TableGroupRow } from '@devexpress/dx-react-grid-material-ui';
import { createElement } from 'react';

var TableGroupRowCellComponent = function TableGroupRowCellComponent(props) {
  return /*#__PURE__*/createElement(TableGroupRow.Cell, _extends({}, props, {
    className: "table-group-row-cell"
  }));
};

export { TableGroupRowCellComponent };